module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel5-fr-FR@2x-de0194ba5c67bad95912c300b3d715b8.png";